// extracted by mini-css-extract-plugin
export default {"errorNotification":"ErrorNotification_errorNotification__r8O8d"};